import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { CoreActions, CoreSelectors, Localization, LocalizationActions, LocalizationSelectors, ModulesSelectors, SosLoaderService } from '@serviceos-ng/core';
import { Observable, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
// import SmartBanner from 'smartbanner.js';

declare global {
    interface Window {
        smartbanner: any;
    }
}

@Component({
    selector: 'serviceos-web-header-screen',
    templateUrl: './header-screen.component.html',
    styleUrls: ['./header-screen.component.scss'],
})
export class HeaderScreenComponent implements OnInit {
    public logoText = '';
    public currentLanguageFlagUrl = '';

    private subscriptions: Subscription[] = [];

    // public currentLanguage = 'en';

    @Select(CoreSelectors.brandName)
    brandName$!: Observable<string>;

    @Select(CoreSelectors.logo)
    logo$!: Observable<string>;

    @Select(LocalizationSelectors.getSelectedLanguage())
    currentLanguage$!: Observable<string>;

    @Select(LocalizationSelectors.getLanguages())
    languages$!: Observable<any>;

    @Select(ModulesSelectors.getModuleConfigText('auth'))
    moduleAuthTexts$!: Observable<any>;

    constructor(
        private store: Store,
        private loaderService: SosLoaderService,
        private router: Router,
        // private smartBanner: SmartBanner
    ) {}

    ngOnInit(): void {

        // const smartBanner = new SmartBanner();

        //   window.smartbanner = smartBanner;

        // window.smartbanner.
        // setTimeout(
        //     () => {
        //         console.log('print smart banner', window.smartbanner);
        //         // console.log('print smart banner2', this.smartBanner);
        //         // console.log('print smart banner2', SB);
        //         window.smartbanner.publish();
        //     }, 3500
        // )

        // document.addEventListener('smartbanner.init', ()=> {
        //     window.smartbanner.price = 'eho meho';
        // });

        this.logoText = this.store.selectSnapshot(CoreSelectors.brandName);

        this.subscriptions.push(this.store.select(LocalizationSelectors.getSelectedLanguage())
            .subscribe((langauge) => {
                this.getCurrentLanguageFlag(langauge);
            }));
    }

    public onLanguageSelect(language) {
        const loader = this.loaderService.showLoader();

        this.getCurrentLanguageFlag(language.code);

        this.store
            .dispatch(new LocalizationActions.ChangeLanguage(language.code))
            .pipe(
                finalize(() => {
                    this.store.dispatch(new CoreActions.InitializeCoreStore$())
                        .pipe(
                            finalize(() => {
                                this.loaderService.hideLoader(loader);
                            })
                        ).subscribe();
                })
            )
            .subscribe();
    }

    private getCurrentLanguageFlag(currentLanguage) {

        const availableLanguages = this.store.selectSnapshot(LocalizationSelectors.getLanguages()),
                currentLanguageItem = availableLanguages.filter((item) => item.code === currentLanguage);

        this.currentLanguageFlagUrl = currentLanguageItem.length && currentLanguageItem[0].icon_url ? currentLanguageItem[0].icon_url : '';
    }

    public logoClick() {

        const logoLink = this.store.selectSnapshot(
            ModulesSelectors.getSetting('website_url')
        );

        if (logoLink) {
            window.location.href = logoLink;
        } else {   
            this.router.navigate(['/']);
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.map((el) => el.unsubscribe());
    }
}
